const replaceBrTagToHyphen = (val: string) => val.replace(/<br\s*[/]?>/gi, '-');

const convertNewlinesToBreaks = (text: string) => {
  return text.replace(/\n/g, '<br>');
};
//
/**

 * toLocaleString で3ケタ区切りのカンマ付きの数値文字列を引数に取り、
 * number 型に変換して返却する
 * 数値に変換できないものは 0 を返す
 * @param {string} numStr - '1,000'
 * @returns {number} - 数値 1000
 */
const removeCommaAndToNumber = (numStr: string): number => {
  return Number.parseFloat(numStr.replace(/,/g, '')) || 0;
};

// 変換例 2024-02-01 -> February 1, 2024
const formatEnDateString = (date: string): string => {
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Parse string of `/path/` or `/path/to/` into the array["path"] or["path", "to"]
 */
const parsePathSegment = (path: string) => {
  return path.split('/').filter((_) => _ !== '');
};

// MicroCMSのリッチテキストのHTMLをdescriptionタグに使うための文字列に変換する
// NOTE: overviewV2 等の MicroCMS optional フィールド（実体は string | undefined）を直接受け取り得るため、
// null/undefined/空文字をガードする（JCAT-5180 / JCAT-4666 hotfix の補修）
const formatHtmlForDescriptionTag = (html: string | null | undefined) => {
  if (html == null || html === '') return '';
  // </p>を行の終わりとして、スペースに置換
  const htmlTagsWithSpace = html.replace(/<\/p>/g, ' ');
  // 開始のpタグと、その他のタグを全て駆除
  const htmlTagsRemoved = htmlTagsWithSpace.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
  // descriptionにurlは不要なので削除
  const urlRemoved = htmlTagsRemoved.replace(/https?:\/\/\S+\s/g, '');
  // 連続するスペースを1つのスペースに置換する関数を書く（microCMSのリッチテキストで１行空の行を追加すると起こる）
  const textWithNoDuplicatedSpace = urlRemoved.replace(/\s+/g, ' ');

  // 文字数はPCの表示文字数に合わせる
  // Ref: https://linear.app/japan-culture-and-technology/issue/JCAT-282/[consumermicrocms]-faqを登録表示することができる#comment-bf4964f7
  return textWithNoDuplicatedSpace.slice(0, 120);
};
// 文字列配列の中から日付形式(YYYY-MM-DD)のものを抽出する
const abstractDateStringFromArray = (strings: string[]): string[] => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return strings.filter((val) => dateRegex.test(val));
};
// 文字列配列の中から日付形式(YYYY-MM-DD)のものを抽出する
const isDateString = (string: string): boolean => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return dateRegex.test(string);
};

// NOTE: overviewV2 等の MicroCMS optional フィールド（実体は string | undefined）を直接受け取り得るため、
// null/undefined/空文字をガードする（JCAT-5180 / JCAT-4666 hotfix の補修）
const stripHtmlTags = (html: string | null | undefined): string => {
  if (html == null || html === '') return '';
  return html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').trim();
};

export {
  replaceBrTagToHyphen,
  convertNewlinesToBreaks,
  formatEnDateString,
  abstractDateStringFromArray,
  parsePathSegment,
  removeCommaAndToNumber,
  formatHtmlForDescriptionTag,
  isDateString,
  stripHtmlTags,
};
